const { ValidationError } = require('@plastiq/external-api-errors')

const BaseValidator = require('./BaseValidator')

class ArrayValidator {
  static validate(argument, argumentName, allowEmpty=false) {
    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    if (!Array.isArray(argument)) {
      throw new ValidationError(`Must be of type array: ${argumentName}`)
    }
    !allowEmpty && validatePopulatedArray(argument, argumentName)
  }
}

function validatePopulatedArray(argument, argumentName) {
  if (argument.length === 0) {
    throw new ValidationError(`Empty array: ${argumentName}`)
  }
}

module.exports = ArrayValidator
